// MEGA MENU
/*const megaMenuButtonDisplaySubmenu = document.querySelectorAll('.navigation__link.display-submenu');
const megaMenuSubmenu = document.querySelectorAll('.subnav');
if (megaMenuButtonDisplaySubmenu && megaMenuSubmenu) {
  megaMenuButtonDisplaySubmenu.forEach(function(btn){
    btn.addEventListener('mouseover', (e)=>{
      e.preventDefault();
      let index = btn.getAttribute("data-index");
      let target = document.querySelectorAll('.subnav.' + index);
      
      megaMenuSubmenu.forEach(function(item){
        item.classList.add('hidden');
      });
      if (target) {
        target.forEach(function(item){
          item.classList.remove('hidden');
        });
      }
    });
  });
}*/

// STICKY
const stickyAnnouncementSection = document.querySelector("#shopify-section-announcement-bar");
const stickyHeaderSection = document.querySelector(".section-header");
const stickyHeaderElem = document.querySelector(".pageheader--sticky");
let stickyHeight;

if (stickyHeaderElem) {
  document.addEventListener("scroll", stickyHeaderCheck, { passive: true });
  stickyHeaderCheck();
}

function stickyHeaderCheck() {
  if (stickyAnnouncementSection) {
    stickyHeaderSection.classList.toggle('is-sticky-step1', (window.scrollY >= stickyAnnouncementSection.clientHeight));
  }
  stickyHeight = (stickyAnnouncementSection ? stickyAnnouncementSection.clientHeight : 0) + 57;
  stickyHeaderSection.classList.toggle('is-sticky-step2', (window.scrollY >= stickyHeight));
}

// JQUERY
$(function(){
  // ANCHOR
  $('.section-mr-anchor a').click(function(e){
    e.preventDefault();

    if ($('#' + $(this).data('id')).length > 0)
      $("html, body").animate({ scrollTop: $('#' + $(this).data('id')).position().top });
  });

  // READ MORE
  $('.description-read-more').click(function(e){
    e.preventDefault();

    $(this).closest('.product-description-read-more').find('.product-description-read-more-2').toggle('fast');
    $(this).find('.more, .less').toggle();
  });

  // TABS
  $('.product-detail-tabs .product-detail-tabs-top .product-detail-tab-button').click(function(e){
    e.preventDefault();

    if (!$(this).is('.active')) {
      const index = $(this).data('index');
      const target = $(this).closest('.product-detail-tabs');
      const top = target.find('.product-detail-tabs-top');
      const button = top.find('.product-detail-tab-button');
      const bottom = target.find('.product-detail-tabs-bottom');
      const content = bottom.find('.product-detail-tab-content');
      
      button.removeClass('active');
      $(this).addClass('active');
  
      content.removeClass('active');
      bottom.find('.product-detail-tab-content[data-index="' + index + '"]').addClass('active');
  
      content.find('.more').show();
      content.find('.less').hide();
      content.find('.read-more-2').hide();
    }
  });
  $('.product-detail-tabs .product-detail-tab-content-read-more').click(function(e){
    e.preventDefault();

    $(this).closest('.product-detail-tab-content').find('.read-more-2').toggle('fast');
    $(this).find('.more, .less').toggle();
  });

  // PRODUCT BACK
  $('.btn-back-product').click(function(e){
    e.preventDefault();
    history.back(1);
  });

  // STICKY ADD TO CART
  if ($('body').is('.template-product')) {
    let label = $('.buy-buttons-row button[type="submit"]').text();
    $('body').append('<div id="sticky-add-to-cart"><a href="#" class="cta-mr outline large"><span>' + label + '</span></a></div>');
    
    $('#sticky-add-to-cart a').click(function(e){
      e.preventDefault();
      $(this).addClass('disable');
      setTimeout(function(){ $('#sticky-add-to-cart a').removeClass('disable'); }, 3000);
      $('.buy-buttons-row button[type="submit"]').click();
    });

    $(window).scroll(function() {
      updateStickyAddToCart();
    });
    updateStickyAddToCart();
  }

  function updateStickyAddToCart() {
    let scrollTop = $(window).scrollTop();
    let btnOffset = $('.buy-buttons-row button[type="submit"]').offset().top;
    let footerOffset = $('#shopify-section-footer').offset().top;
    let screenHeight = screen.height;
    
    if (scrollTop <= (btnOffset - screenHeight)) $('#sticky-add-to-cart').addClass('on');
    else if (scrollTop > (footerOffset - screenHeight)) $('#sticky-add-to-cart').removeClass('on');
    else if (scrollTop > btnOffset) $('#sticky-add-to-cart').addClass('on');
    else $('#sticky-add-to-cart').removeClass('on');
  }

  // WISEPOPS
  $('a.newsletter-popup-fr').click(function(e){
    e.preventDefault();
    wisepops("event", "newsletter-popup-fr");
  });
  
  $('a.newsletter-popup-en').click(function(e){
    e.preventDefault();
    wisepops("event", "newsletter-popup-en");
  });
});